import { withRouter} from "react-router-dom";
import { ModalGeneric } from "../../../components/ModalGeneric";
import { InputSearch } from "../../../components/inputSearch";
import { TableItems } from "../../../components/Table";
import { useCadEmpresas } from "../../../hooks/useCadEmpresas";
import * as StyleGlobal from '../../../shared/GlobalStyles/styles'

export const CadEmpresas = (props) => {
  const {
    CadEmpresa, setCadEmpresa, inputRef,
    HandleCliqueHref, filteredData, isFiltering
  } = useCadEmpresas(props)


  return(
    <ModalGeneric.Root close={props.onClose}>
      <ModalGeneric.Header Title={'Empresas Cadastradas'} onClose={props.onClose}/>
        <ModalGeneric.Body>
            <InputSearch ref={inputRef}/>


            <StyleGlobal.BoxGrid>
              {
                isFiltering ? <StyleGlobal.P>Buscando...</StyleGlobal.P> :(

                  (CadEmpresa.length > 0 || filteredData.length > 0)  &&
                  <TableItems
                    valueState={filteredData.length > 0 ? filteredData : CadEmpresa} 
                    nameState={'cadEmpresas'}
                    setState={(value) => setCadEmpresa(value)}
                    handleClickButton={HandleCliqueHref}
                    aggregation={{
                      model:{
                          nome_empresa:'count',
                      }
                    }}
                  />
                )

              }

            </StyleGlobal.BoxGrid>

        </ModalGeneric.Body>
    </ModalGeneric.Root>
  )
}  

export default withRouter(CadEmpresas);